import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
import Resizer from "react-image-file-resizer"

import '../../styles/pacientesPendientes.css'
import '../../styles/tarjetaContenedor.css'

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';
import { saveFile, getFile,surgeryroomCollection } from '../../firebase/config';

import { updateMedicalCredential } from '../../objects/asociado';


const SelectorImagen = ({cantidadPacientes,paciente,documentoSeleccionado,setIsMostrarUsuarios,isReadOnly}) => {

    const [url,setUrl] = useState("")
    const [documento,setDocumento] = useState("")
    const [hadUrl,setHadUrl] = useState(false)
    const [file, setFile] = useState()
    const [ruta, setRuta] = useState()

    const [etiquetaNombre, setEtiquetaNombre] = useState("")

    useEffect(()=>{
        if(documentoSeleccionado){
            let five = new Date().getFullYear();
            let four = five -1;
            let three = four -1;
            let two = three - 1
            let one = two - 1
            if(documentoSeleccionado === 1){
                setDocumento("Copia título profesional ")
            }
            else{
                if(documentoSeleccionado === 2){
                    setDocumento("Copia cédula profesional ")
                }
                else{
                    if(documentoSeleccionado === 3){
                        setDocumento("Copia cédula especialidad ")
                    }
                    else{
                        if(documentoSeleccionado === 4){
                            setDocumento("Copia título especialidad ")
                        }
                        else{
                            if(documentoSeleccionado === 5){
                                setDocumento("Copia título subespecialidad ")
                            }
                            else{
                                if(documentoSeleccionado === 6){
                                    setDocumento("Currículum Vitae ")
                                }
                                else{
                                    if(documentoSeleccionado === 7){
                                        setDocumento("Fotografía ")
                                    }
                                    else{
                                        if(documentoSeleccionado === 8){
                                            setDocumento("INE ")
                                        }
                                        else{
                                            if(documentoSeleccionado === 9){
                                                setDocumento("RFC ")
                                            }
                                            else{
                                                if(documentoSeleccionado === 10){
                                                    setDocumento("Copia del Aviso de funcionamiento de consultorio ")
                                                }
                                                else{
                                                    if(documentoSeleccionado === 11){
                                                        setDocumento("Copia del Registro estatal de profesiones ")
                                                    }
                                                    else{
                                                        if(documentoSeleccionado === 12){
                                                            setDocumento("Copia de la Cédula profesional de sub especialidad ")
                                                        }
                                                        else{
                                                            if(documentoSeleccionado === 13){
                                                                setDocumento("Copia de la Certificación de consejo de especialidad ")
                                                            }
                                                            else{
                                                                if(documentoSeleccionado === 14){
                                                                    setDocumento("Constancias de cursos o congresos " + one + " ")
                                                                }
                                                                else{
                                                                    if(documentoSeleccionado === 15){
                                                                        setDocumento("Constancias de cursos o congresos " + two + " ")
                                                                    }
                                                                    else{
                                                                        if(documentoSeleccionado === 16){
                                                                            setDocumento("Constancias de cursos o congresos " + three + " ")
                                                                        }
                                                                        else{
                                                                            if(documentoSeleccionado === 17){
                                                                                setDocumento("Constancias de cursos o congresos " + four + " ")
                                                                            }
                                                                            else{
                                                                                if(documentoSeleccionado === 18){
                                                                                    setDocumento("Constancias de cursos o congresos " + five + " ")
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if(paciente){
            if(paciente.gender === "1"){
                setEtiquetaNombre("" + paciente.name + " " + paciente.lastname)
            }
            else{
                setEtiquetaNombre("" + paciente.name + " " + paciente.lastname)
            }
        }
    },[documentoSeleccionado,paciente])

    useEffect(()=>{
        let ruta = surgeryroomCollection+"/docs/"
        if(paciente){
            let five = new Date().getFullYear();
            let four = five -1;
            let three = four -1;
            let two = three - 1
            let one = two - 1
            ruta += paciente.hospital + "/" + paciente.identificador + "/"
            if(documentoSeleccionado){
                if(documentoSeleccionado === 1){
                    ruta += "copy_professional_title"
                    setRuta(ruta)
                    if(paciente.url_copy_professional_title && paciente.copy_professional_title){
                        setHadUrl(true)
                        solicitarArchivo()
                        async function solicitarArchivo(){
                            const response = await getFile(paciente.url_copy_professional_title)
                            setUrl(response)
                        }
                        //setUrl(paciente.base_copy_professional_title)
                    }
                    else{
                        setHadUrl(false)
                        setUrl("")
                    }
                }
                else{
                    if(documentoSeleccionado === 2){
                        ruta += "copy_professional_license"
                        setRuta(ruta)
                        if(paciente.url_copy_professional_license && paciente.copy_professional_license){
                            setHadUrl(true)
                            solicitarArchivo()
                            async function solicitarArchivo(){
                                const response = await getFile(paciente.url_copy_professional_license)
                                setUrl(response)
                            }
                            //setUrl(paciente.base_copy_professional_license)
                        }
                        else{
                            setHadUrl(false)
                            setUrl("")
                        }
                    }
                    else{
                        if(documentoSeleccionado === 3){
                            ruta += "copy_specialty_certificate"
                            setRuta(ruta)
                            if(paciente.url_copy_specialty_certificate && paciente.copy_specialty_certificate){
                                setHadUrl(true)
                                solicitarArchivo()
                                async function solicitarArchivo(){
                                    const response = await getFile(paciente.url_copy_specialty_certificate)
                                    setUrl(response)
                                }
                                //setUrl(paciente.base_copy_specialty_certificate)
                            }
                            else{
                                setHadUrl(false)
                                setUrl("")
                            }
                        }
                        else{
                            if(documentoSeleccionado === 4){
                                ruta += "copy_specialty_title"
                                setRuta(ruta)
                                if(paciente.url_copy_specialty_title && paciente.copy_specialty_title){
                                    setHadUrl(true)
                                    solicitarArchivo()
                                    async function solicitarArchivo(){
                                        const response = await getFile(paciente.url_copy_specialty_title)
                                        setUrl(response)
                                    }
                                    //setUrl(paciente.base_copy_specialty_title)
                                }
                                else{
                                    setHadUrl(false)
                                    setUrl("")
                                }
                            }
                            else{
                                if(documentoSeleccionado === 5){
                                    ruta += "copy_subspecial_title"
                                    setRuta(ruta)
                                    if(paciente.url_copy_subspecial_title && paciente.copy_subspecial_title){
                                        setHadUrl(true)
                                        solicitarArchivo()
                                        async function solicitarArchivo(){
                                            const response = await getFile(paciente.url_copy_subspecial_title)
                                            setUrl(response)
                                        }
                                        //setUrl(paciente.base_copy_subspecial_title)
                                    }
                                    else{
                                        setHadUrl(false)
                                        setUrl("")
                                    }
                                }
                                else{
                                    if(documentoSeleccionado === 6){
                                        ruta += "curriculum_vitae"
                                        setRuta(ruta)
                                        if(paciente.url_curriculum_vitae && paciente.curriculum_vitae){
                                            setHadUrl(true)
                                            solicitarArchivo()
                                            async function solicitarArchivo(){
                                                const response = await getFile(paciente.url_curriculum_vitae)
                                                setUrl(response)
                                            }
                                            //setUrl(paciente.baseCv)
                                        }
                                        else{
                                            setHadUrl(false)
                                            setUrl("")
                                        }
                                    }
                                    else{
                                        if(documentoSeleccionado === 7){
                                            ruta += "photo"
                                            setRuta(ruta)
                                            if(paciente.url_photo && paciente.photo){
                                                setHadUrl(true)
                                                solicitarArchivo()
                                                async function solicitarArchivo(){
                                                    const response = await getFile(paciente.url_photo)
                                                    setUrl(response)
                                                }
                                                //setUrl(paciente.basefotografia)
                                            }
                                            else{
                                                setHadUrl(false)
                                                setUrl("")
                                            }
                                        }
                                        else{
                                            if(documentoSeleccionado === 8){
                                                ruta += "ine"
                                                setRuta(ruta)
                                                if(paciente.url_ine && paciente.ine){
                                                    setHadUrl(true)
                                                    solicitarArchivo()
                                                    async function solicitarArchivo(){
                                                        const response = await getFile(paciente.url_ine)
                                                        setUrl(response)
                                                    }
                                                    //setUrl(paciente.baseine)
                                                }
                                                else{
                                                    setHadUrl(false)
                                                    setUrl("")
                                                }
                                            }
                                            else{
                                                if(documentoSeleccionado === 9){
                                                    ruta += "rfc"
                                                    setRuta(ruta)
                                                    if(paciente.url_rfc && paciente.rfc){
                                                        setHadUrl(true)
                                                        solicitarArchivo()
                                                        async function solicitarArchivo(){
                                                            const response = await getFile(paciente.url_rfc)
                                                            setUrl(response)
                                                        }
                                                        //setUrl(paciente.baserfc)
                                                    }
                                                    else{
                                                        setHadUrl(false)
                                                        setUrl("")
                                                    }
                                                }
                                                else{
                                                    if(documentoSeleccionado === 10){
                                                        ruta += "copy_of_office_operating_notice"
                                                        setRuta(ruta)
                                                        if(paciente.url_copy_of_office_operating_notice && paciente.copy_of_office_operating_notice){
                                                            setHadUrl(true)
                                                            solicitarArchivo()
                                                            async function solicitarArchivo(){
                                                                const response = await getFile(paciente.url_copy_of_office_operating_notice)
                                                                setUrl(response)
                                                            }
                                                            //setUrl(paciente.base_copy_of_office_operating_notice)
                                                        }
                                                        else{
                                                            setHadUrl(false)
                                                            setUrl("")
                                                        }
                                                    }
                                                    else{
                                                        if(documentoSeleccionado === 11){
                                                            ruta += "copy_state_registry_of_professions"
                                                            setRuta(ruta)
                                                            if(paciente.url_copy_state_registry_of_professions && paciente.copy_state_registry_of_professions){
                                                                setHadUrl(true)
                                                                solicitarArchivo()
                                                                async function solicitarArchivo(){
                                                                    const response = await getFile(paciente.url_copy_state_registry_of_professions)
                                                                    setUrl(response)
                                                                }
                                                                //setUrl(paciente.base_copy_state_registry_of_professions)
                                                            }
                                                            else{
                                                                setHadUrl(false)
                                                                setUrl("")
                                                            }
                                                        }
                                                        else{
                                                            if(documentoSeleccionado === 12){
                                                                ruta += "copy_subspecialty_professional_certificate"
                                                                setRuta(ruta)
                                                                if(paciente.url_copy_subspecialty_professional_certificate && paciente.copy_subspecialty_professional_certificate){
                                                                    setHadUrl(true)
                                                                    solicitarArchivo()
                                                                    async function solicitarArchivo(){
                                                                        const response = await getFile(paciente.url_copy_subspecialty_professional_certificate)
                                                                        setUrl(response)
                                                                    }
                                                                    //setUrl(paciente.base_copy_subspecialty_professional_certificate)
                                                                }
                                                                else{
                                                                    setHadUrl(false)
                                                                    setUrl("")
                                                                }
                                                            }
                                                            else{
                                                                if(documentoSeleccionado === 13){
                                                                    ruta += "copy_specialty_board_certification"
                                                                    setRuta(ruta)
                                                                    if(paciente.url_copy_specialty_board_certification && paciente.copy_specialty_board_certification){
                                                                        setHadUrl(true)
                                                                        solicitarArchivo()
                                                                        async function solicitarArchivo(){
                                                                            const response = await getFile(paciente.url_copy_specialty_board_certification)
                                                                            setUrl(response)
                                                                        }
                                                                        //setUrl(paciente.base_copy_specialty_board_certification)
                                                                    }
                                                                    else{
                                                                        setHadUrl(false)
                                                                        setUrl("")
                                                                    }
                                                                }
                                                                else{
                                                                    if(documentoSeleccionado === 14){
                                                                        ruta += "/contancies/" + one
                                                                        setRuta(ruta)
                                                                        let bandera = false
                                                                        let url_bandera = ""
                                                                        let send_bandera = false
                                                                        for(let i=0;i<paciente.contancies.length;i++){
                                                                            if(one === paciente.contancies[i].year){
                                                                                bandera = true
                                                                                url_bandera = paciente.contancies[i].url
                                                                                send_bandera = paciente.contancies[i].sendig
                                                                            }
                                                                        }
                                                                        if(bandera && url_bandera && send_bandera){
                                                                            setHadUrl(true)
                                                                            solicitarArchivo()
                                                                            async function solicitarArchivo(){
                                                                                const response = await getFile(ruta)
                                                                                setUrl(response)
                                                                            }
                                                                            //setUrl(paciente.base_contancies_one)
                                                                        }
                                                                        else{
                                                                            setHadUrl(false)
                                                                            setUrl("")
                                                                        }
                                                                    }
                                                                    else{
                                                                        if(documentoSeleccionado === 15){
                                                                            ruta += "/contancies/" + two
                                                                            setRuta(ruta)
                                                                            let bandera = false
                                                                            let url_bandera = ""
                                                                            let send_bandera = false

                                                                            for(let i=0;i<paciente.contancies.length;i++){
                                                                                if(two === paciente.contancies[i].year){
                                                                                    bandera = true
                                                                                    url_bandera = paciente.contancies[i].url
                                                                                    send_bandera = paciente.contancies[i].sendig
                                                                                }
                                                                            }
                                                                            if(bandera && url_bandera && send_bandera){
                                                                                setHadUrl(true)
                                                                                solicitarArchivo()
                                                                                async function solicitarArchivo(){
                                                                                    const response = await getFile(ruta)
                                                                                    setUrl(response)
                                                                                }
                                                                            }
                                                                            else{
                                                                                setHadUrl(false)
                                                                                setUrl("")
                                                                            }
                                                                        }
                                                                        else{
                                                                            if(documentoSeleccionado === 16){
                                                                                ruta += "/contancies/" + three
                                                                                setRuta(ruta)
                                                                                let bandera = false
                                                                                let url_bandera = ""
                                                                                let send_bandera = false
                                                                                for(let i=0;i<paciente.contancies.length;i++){
                                                                                    if(three === paciente.contancies[i].year){
                                                                                        bandera = true
                                                                                        url_bandera = paciente.contancies[i].url
                                                                                        send_bandera = paciente.contancies[i].sendig
                                                                                    }
                                                                                }
                                                                                if(bandera && url_bandera && send_bandera){
                                                                                    setHadUrl(true)
                                                                                    solicitarArchivo()
                                                                                    async function solicitarArchivo(){
                                                                                        const response = await getFile(ruta)
                                                                                        setUrl(response)
                                                                                    }
                                                                                }
                                                                                else{
                                                                                    setHadUrl(false)
                                                                                    setUrl("")
                                                                                }
                                                                            }
                                                                            else{
                                                                                if(documentoSeleccionado === 17){
                                                                                    ruta += "/contancies/" + four
                                                                                    setRuta(ruta)
                                                                                    let bandera = false
                                                                                    let url_bandera = ""
                                                                                    let send_bandera = false
                                                                                    for(let i=0;i<paciente.contancies.length;i++){
                                                                                        if(four === paciente.contancies[i].year){
                                                                                            bandera = true
                                                                                            url_bandera = paciente.contancies[i].url
                                                                                            send_bandera = paciente.contancies[i].sendig
                                                                                        }
                                                                                    }
                                                                                    if(bandera && url_bandera && send_bandera){
                                                                                        setHadUrl(true)
                                                                                        solicitarArchivo()
                                                                                        async function solicitarArchivo(){
                                                                                            const response = await getFile(ruta)
                                                                                            setUrl(response)
                                                                                        }
                                                                                    }
                                                                                    else{
                                                                                        setHadUrl(false)
                                                                                        setUrl("")
                                                                                    }
                                                                                }
                                                                                else{
                                                                                    if(documentoSeleccionado === 18){
                                                                                        ruta += "/contancies/" + five
                                                                                        setRuta(ruta)
                                                                                        let bandera = false
                                                                                        let url_bandera = ""
                                                                                        let send_bandera = false
                                                                                        for(let i=0;i<paciente.contancies.length;i++){
                                                                                            if(five === paciente.contancies[i].year){
                                                                                                bandera = true
                                                                                                url_bandera = paciente.contancies[i].url
                                                                                                send_bandera = paciente.contancies[i].sendig
                                                                                            }
                                                                                        }
                                                                                        if(bandera && url_bandera && send_bandera){
                                                                                            setHadUrl(true)
                                                                                            solicitarArchivo()
                                                                                            async function solicitarArchivo(){
                                                                                                const response = await getFile(ruta)
                                                                                                setUrl(response)
                                                                                            }
                                                                                        }
                                                                                        else{
                                                                                            setHadUrl(false)
                                                                                            setUrl("")
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },[paciente,documentoSeleccionado])


    const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      270,
      270,
      "PNG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

    const handleActualizarDocumento = (paciente) => (event) => {
        event.preventDefault()
        let mensaje = ""
        switch(documentoSeleccionado){
            case 1:
                mensaje = "¿Desea guardar la Copia título profesional de " +etiquetaNombre + "?"
                break
            case 2:
                mensaje = "¿Desea guardar la Copia cédula profesional de " +etiquetaNombre + "?"
                break
            case 3:
                mensaje = "¿Desea guardar la Copia cédula especialidad de " +etiquetaNombre + "?"
                break
            case 4:
                mensaje = "¿Desea guardar la Copia título especialidad de " +etiquetaNombre + "?"
                break
            case 5:
                mensaje = "¿Desea guardar la Copia título subespecialidad de " +etiquetaNombre + "?"
                break
            case 6:
                mensaje = "¿Desea guardar el Currículum Vitae de " +etiquetaNombre + "?"
                break
            case 7:
                mensaje = "¿Desea guardar la Fotografía de " +etiquetaNombre + "?"
                break
            case 8:
                mensaje = "¿Desea guardar la Copia del INE de " +etiquetaNombre + "?"
                break
            case 9:
                mensaje = "¿Desea guardar la Copia del RFC de " +etiquetaNombre + "?"
                break
            case 10:
                mensaje = "¿Desea guardar la Copia del Aviso de funcionamiento de consultorio de " +etiquetaNombre + "?"
                break
            case 11:
                mensaje = "¿Desea guardar la Copia del Registro estatal de profesiones de " +etiquetaNombre + "?"
                break
            case 12:
                mensaje = "¿Desea guardar la Copia de la Cédula profesional de sub especialidad de " +etiquetaNombre + "?"
                break
            case 13:
                mensaje = "¿Desea guardar la Copia de la Certificación de consejo de especialidad de " +etiquetaNombre + "?"
                break
            case 14:
                mensaje = "¿Desea guardar la " + documento + " de " +etiquetaNombre + "?"
                break
            case 15:
                mensaje = "¿Desea guardar la " + documento + " de " +etiquetaNombre + "?"
                break
            case 16:
                mensaje = "¿Desea guardar la " + documento + " de " +etiquetaNombre + "?"
                break
            case 17:
                mensaje = "¿Desea guardar la " + documento + " de " +etiquetaNombre + "?"
                break
            case 18:
                mensaje = "¿Desea guardar la " + documento + " de " +etiquetaNombre + "?"
                break
            default:
                mensaje = ""
        }
        Swal.fire({
            title: mensaje,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
              switch(documentoSeleccionado){
                    case 1:
                        paciente.url_copy_professional_title = ruta
                        paciente.copy_professional_title = true
                        paciente.base_copy_professional_title = ''
                        break
                    case 2:
                        paciente.url_copy_professional_license = ruta
                        paciente.copy_professional_license = true
                        paciente.base_copy_professional_license = ''
                        break
                    case 3:
                        paciente.url_copy_specialty_certificate = ruta
                        paciente.copy_specialty_certificate = true
                        paciente.base_copy_specialty_certificate = ''
                        break
                    case 4:
                        paciente.url_copy_specialty_title = ruta
                        paciente.copy_specialty_title = true
                        paciente.base_copy_specialty_title = ''
                        break
                    case 5:
                        paciente.url_copy_subspecial_title = ruta
                        paciente.copy_subspecial_title = true
                        paciente.base_copy_subspecial_title = ''
                        break
                    case 6:
                        paciente.url_curriculum_vitae = ruta
                        paciente.curriculum_vitae = true
                        paciente.baseCv = ''
                        break
                    case 7:
                        paciente.url_photo = ruta
                        paciente.photo = true
                        paciente.basefotografia = url
                        break
                    case 8:
                        paciente.url_ine = ruta
                        paciente.ine = true
                        paciente.baseine = ''
                        break
                    case 9:
                        paciente.url_rfc = ruta
                        paciente.rfc = true
                        paciente.baserfc = ''
                        break
                    case 10:
                        paciente.url_copy_of_office_operating_notice = ruta
                        paciente.copy_of_office_operating_notice = true
                        paciente.base_copy_of_office_operating_notice = ''
                        break
                    case 11:
                        paciente.url_copy_state_registry_of_professions = ruta
                        paciente.copy_state_registry_of_professions = true
                        paciente.base_copy_state_registry_of_professions = ''
                        break
                    case 12:
                        paciente.url_copy_subspecialty_professional_certificate = ruta
                        paciente.copy_subspecialty_professional_certificate = true
                        paciente.base_copy_subspecialty_professional_certificate = ''
                        break
                    case 13:
                        paciente.url_copy_specialty_board_certification = ruta
                        paciente.copy_specialty_board_certification = true
                        paciente.base_copy_specialty_board_certification = ''
                        break
                    case 14:
                        paciente.contancies[0].url = ruta
                        paciente.contancies[0].sendig = true
                        //paciente.base_contancies_one = url
                        break
                    case 15:
                        paciente.contancies[1].url = ruta
                        paciente.contancies[1].sendig = true
                        break
                    case 16:
                        paciente.contancies[2].url = ruta
                        paciente.contancies[2].sendig = true
                        break
                    case 17:
                        paciente.contancies[3].url = ruta
                        paciente.contancies[3].sendig = true
                        break
                    case 18:
                        paciente.contancies[4].url = ruta
                        paciente.contancies[4].sendig = true
                        break
                    default:
                        mensaje = ""
                        break
                }

                if(!paciente.url_copy_professional_title){
                    paciente.url_copy_professional_title = ''
                }

                if(!paciente.url_copy_professional_license){
                    paciente.url_copy_professional_license = ''
                }

                if(!paciente.url_copy_specialty_certificate){
                    paciente.url_copy_specialty_certificate = ''
                }

                if(!paciente.url_copy_specialty_title){
                    paciente.url_copy_specialty_title = ''
                }

                if(!paciente.url_copy_subspecial_title){
                    paciente.url_copy_subspecial_title = ''
                }

                if(!paciente.url_curriculum_vitae){
                    paciente.url_curriculum_vitae = ''
                }

                if(!paciente.url_photo){
                    paciente.url_photo = ''
                }

                if(!paciente.url_ine){
                    paciente.url_ine = ''
                }

                if(!paciente.url_rfc){
                    paciente.url_rfc = ''
                }

                if(!paciente.url_copy_of_office_operating_notice){
                    paciente.url_copy_of_office_operating_notice = ''
                }

                if(!paciente.url_copy_state_registry_of_professions){
                    paciente.url_copy_state_registry_of_professions = ''
                }

                if(!paciente.basefotografia){
                    paciente.basefotografia = ''
                }

                if(!paciente.baseine){
                    paciente.baseine = ''
                }

                if(!paciente.baseCv){
                    paciente.baseCv = ''
                }

                if(!paciente.base_copy_professional_title){
                    paciente.base_copy_professional_title = ''
                }

                if(!paciente.base_copy_professional_license){
                    paciente.base_copy_professional_license = ''
                }

                if(!paciente.base_copy_specialty_title){
                    paciente.base_copy_specialty_title = ''
                }

                if(!paciente.base_copy_specialty_certificate){
                    paciente.base_copy_specialty_certificate = ''
                }

                if(!paciente.base_copy_subspecial_title){
                    paciente.base_copy_subspecial_title = ''
                }

                if(!paciente.base_copy_specialty_board_certification){
                    paciente.base_copy_specialty_board_certification = ''
                }

                if(!paciente.base_copy_of_office_operating_notice){
                    paciente.base_copy_of_office_operating_notice = ''
                }

                if(!paciente.base_copy_state_registry_of_professions){
                    paciente.base_copy_state_registry_of_professions = ''
                }

                if(!paciente.copiaTituloProfesionalDay){
                    paciente.copiaTituloProfesionalDay = ''
                }

                if(!paciente.copiaTituloProfesionalExpiraDay){
                    paciente.copiaTituloProfesionalExpiraDay = ''
                }

                if(!paciente.tituloProfesionalExpedidoPor){
                    paciente.tituloProfesionalExpedidoPor = ''
                }

                if(!paciente.copiaCedulaProfesionalDay){
                    paciente.copiaCedulaProfesionalDay = ''
                }

                if(!paciente.copiaCedulaProfesionalExpiraDay){
                    paciente.copiaCedulaProfesionalExpiraDay = ''
                }

                if(!paciente.CedulaProfesionalExpedidoPor){
                    paciente.CedulaProfesionalExpedidoPor = ''
                }

                if(!paciente.copiaCedulaEspecialidadDay){
                    paciente.copiaCedulaEspecialidadDay = ''
                }

                if(!paciente.copiaCedulaEspecialidadExpiraDay){
                    paciente.copiaCedulaEspecialidadExpiraDay = ''
                }

                if(!paciente.CedulaEspecialidadExpedidoPor){
                    paciente.CedulaEspecialidadExpedidoPor = ''
                }

                if(!paciente.copiaTituloEspecialidadDay){
                    paciente.copiaTituloEspecialidadDay = ''
                }

                if(!paciente.copiaTituloEspecialidadExpiraDay){
                    paciente.copiaTituloEspecialidadExpiraDay = ''
                }

                if(!paciente.copiaTituloEspecialidadExpedidoPor){
                    paciente.copiaTituloEspecialidadExpedidoPor = ''
                }

                if(!paciente.copiaTituloSubEspecialidadDay){
                    paciente.copiaTituloSubEspecialidadDay = ''
                }

                if(!paciente.copiaTituloSubEspecialidadExpiraDay){
                    paciente.copiaTituloSubEspecialidadExpiraDay = ''
                }

                if(!paciente.copiaTituloSubEspecialidadExpedidoPor){
                    paciente.copiaTituloSubEspecialidadExpedidoPor = ''
                }

                if(!paciente.copiaTituloSubespecialidadDay){
                    paciente.copiaTituloSubespecialidadDay = ''
                }

                if(!paciente.copiaTituloSubespecialidadExpiraDay){
                    paciente.copiaTituloSubespecialidadExpiraDay = ''
                }

                if(!paciente.copiaTituloSubespecialidadExpedidoPor){
                    paciente.copiaTituloSubespecialidadExpedidoPor = ''
                }

                if(!paciente.certificacionConsejoEspecialidadDay){
                    paciente.certificacionConsejoEspecialidadDay = ''
                }

                if(!paciente.certificacionConsejoEspecialidadExpiraDay){
                    paciente.certificacionConsejoEspecialidadExpiraDay = ''
                }

                if(!paciente.certificacionConsejoEspecialidadExpedidoPor){
                    paciente.certificacionConsejoEspecialidadExpedidoPor = ''
                }

                if(!paciente.avisoFuncionamientoDay){
                    paciente.avisoFuncionamientoDay = ''
                }

                if(!paciente.avisoFuncionamientoExpiraDay){
                    paciente.avisoFuncionamientoExpiraDay = ''
                }

                if(!paciente.avisoFuncionamientoExpedidoPor){
                    paciente.avisoFuncionamientoExpedidoPor = ''
                }

                if(!paciente.registroEstatalProfesionalesDay){
                    paciente.registroEstatalProfesionalesDay = ''
                }

                if(!paciente.registroEstatalProfesionalesExpiraDay){
                    paciente.registroEstatalProfesionalesExpiraDay = ''
                }

                if(!paciente.registroEstatalProfesionalesExpedidoPor){
                    paciente.registroEstatalProfesionalesExpedidoPor = ''
                }

                let hoy = new Date()
                    if(!paciente.create){
                        paciente.create = hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
                    }

                actualizarCredential()
                async function actualizarCredential(){
                    const response = await updateMedicalCredential(paciente.id,paciente)

                    if(response === "success"){//Actualización de usuario exitosa
                        saveFile(file,ruta)
                         
                        let timerInterval
                        Swal.fire({
                        icon: 'success',
                        title: 'Credencial actualizada',
                        text: 'Credencial actualizada de manera correcta',
                        timer: 2000,
                        timerProgressBar: false,
                        didOpen: () => {
                            Swal.showLoading()
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                        }
                        }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            setIsMostrarUsuarios(false)
                        }
                        })
                        // Swal.fire({
                        //     icon: 'success',
                        //     title: 'Credencial actualizada',
                        //     text: 'Credencial actualizada de manera correcta',
                        //     confirmButtonText: "Aceptar",
                        //     confirmButtonColor: "#04afaa",
                        //   })
                    }
                    else{//Error en la actualización de usuario
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response,
                          })
                    }
                }
            }
          })
    }

    const handleAgregar = () => (event) => {
        event.preventDefault()
        setIsMostrarUsuarios(false)
    }

    return(
        <>
        <section className='seccion_pacientes_pendientes'>
            <div id="cuerpoEncabezado" className='cuerpoEncabezado'>
                <button className="btn-flotante" title="Regresar" alt="Regresar" onClick={handleAgregar()}>X Regresar</button>
                <EncabezadoSeccion tituloInicial={documento} tituloFinal={paciente.identificador +" "+etiquetaNombre} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadPacientes}/>
            </div>
            <div className='itemservespCont'>
                <div className={"itemImage"}>
                <label htmlFor="files" className="input">Seleccione la {documento}</label>
                <input type="file" id="files" className='file' onChange={(input)=> {

                    let file = input.target.files[0];
                    setFile(file)
                    let reader = new FileReader();

                    reducir()
                                            async function reducir(){
                                                const image = await resizeFile(file);
                                                setUrl(image)
                                            }

                    //reader.readAsText(file);
                    reader.readAsDataURL(file);
                    reader.onload = function() {
                        //console.log(reader.result)
                        setUrl(reader.result)
                    };

                    reader.onerror = function() {
                        //console.log(reader.error);
                    };

                }} accept='image/*,.pdf'/>
                <iframe
                    src={url}
                    //src='https://apibot.hospitalesmac.app/public/labels/asdfsdf/345345354adfgd/a345345345/sdgdsfsdfsdfa/a43543534543/5fe72104fac6af0fa95dbbb0e910fde7'
                    height={"600px"} 
                    width={"800px"}
                    key={paciente.id}
                    title={documento}
                />
                {
                    !isReadOnly
                        ?
                            <>
                                {
                                    hadUrl
                                        ?
                                            <p className='boton_uno' onClick={handleActualizarDocumento(paciente)}>Actualizar</p>
                                        :
                                            <p className='boton_uno' onClick={handleActualizarDocumento(paciente)}>Guardar</p>
                                }
                            </>
                        :
                                null
                }
                
                </div>
            </div>
        </section>
        </>
    )
}

export default SelectorImagen